enum UserSelectVariant {
  email = 'email',
  name = 'name'
}
export default UserSelectVariant;
